/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
import {
    IconCardCustomAccess,
    IconChipDepartment, IconChipMultiplePerson, IconChipNone,
    IconEntryDevice,
    IconEntryExitDevice,
    IconExitDevice, IconPersonPlusCard
} from "../../../../components/buttons/IconButtons";
import {permissionObj} from "../../../../Helpers/permission";

export const DEVICE_MODEL_NAME = {
    TELPO_TPS_450: 5,
    TELPO_K5: 6,
    TELPO_F10: 7,
    TELPO_K10: 9,
    CAMERA_LPR: 12,
    ANTENNA_RFID: 13,
    ARATEK_BM7550: 14,
    ARATEK_BA8300: 15,
    ARATEK_BM5510: 16,
    ARATEK_BD8500: 17,
};
export const ANTIPASSBACKTYPE_MODEL = {
    NONE : 1,
    SOFT : 2,
    HARD : 3,
}
export const TYPE_CAMERA_MODEL = {
    0 : 'RGB',
    1 : 'RGB + IR'
}

export const MODE_MODEL = {
    ACCESS : 1,
    ATTENDANCE : 2,
    ACCESS_AND_ATTENDANCE : 3,
    FOODIE_ACCESS : 4,
    FOODIE_KIOSK : 5,
    FOODIE_CHECK_IN : 6,
    GUARD : 7,
    VISITORS_MANAGEMENT_KIOSK : 8,
    CAMERA_LPR : 9,
    ANTENNA : 10,
    FOODIE_CHECK_OUT: 11,
    RESERVATIONS: 12
}
export const AUTHENTICATION_MODE = [
    { id: 0, trans: 'none', name: 'NONE' },
    { id: 1, trans: 'one_fa', name: 'ONE_AF_ONLY' },
    { id: 2, trans: 'two_fa', name: 'TWO_AF_ONLY' },
    { id: 3, trans: 'both', name: 'BOTH' },
];

export const DEVICE_ACCESS_TYPE_MODEL = {
    ENTRY: { id: 1, trans: "entry", name: "ENTRY", transWithDevice: "entry_device", Icon: IconEntryDevice ,color : 'icon-color-success-600'},
    EXIT: { id: 2, trans: "exit", name: "EXIT", transWithDevice: "exit_device",Icon: IconExitDevice,color : 'icon-color-error-code-600'},
    ENTRY_EXIT: { id: 3, trans: "entry_exit",name: "ENTRY_EXIT", transWithDevice: "entry_exit_device", Icon: IconEntryExitDevice},
    NONE: { id: 4, trans: "none",name: "NONE", transWithDevice: "none", Icon: IconChipNone}
}

export const getDeviceAccessTypeById = (id) => {
    const key = Object.entries(DEVICE_ACCESS_TYPE_MODEL).find(key => key[1]?.id === id);
    return key[1] || null;
}
export const ALLOWED_DISTANCE = {
    [DEVICE_MODEL_NAME.TELPO_F10]: [30, 50, 80, 100, 150],
    [DEVICE_MODEL_NAME.TELPO_K10]: [30, 50, 80, 100, 150],
    [DEVICE_MODEL_NAME.ARATEK_BM7550]: [30, 50, 80, 100, 150],
    [DEVICE_MODEL_NAME.ARATEK_BA8300]: [30, 50, 80, 100, 150],
    [DEVICE_MODEL_NAME.ARATEK_BM5510]: [30, 50, 80, 100, 150],
    [DEVICE_MODEL_NAME.ARATEK_BD8500]: [30, 50, 80, 100, 150],
};
export const DEFAULT_DISTANCE_VALUE = {
    [DEVICE_MODEL_NAME.TELPO_TPS_450]: 0,
    [DEVICE_MODEL_NAME.TELPO_K5]: 0,
    [DEVICE_MODEL_NAME.TELPO_F10]: 150,
    [DEVICE_MODEL_NAME.TELPO_K10]: 150,
    [DEVICE_MODEL_NAME.CAMERA_LPR]: 0,
    [DEVICE_MODEL_NAME.ANTENNA_RFID]: 0,
    [DEVICE_MODEL_NAME.ARATEK_BM7550]: 150,
    [DEVICE_MODEL_NAME.ARATEK_BA8300]: 150,
    [DEVICE_MODEL_NAME.ARATEK_BM5510]: 150,
    [DEVICE_MODEL_NAME.ARATEK_BD8500]: 150,
};
export const DISABLE_CAMERA_ANTENNA = [
    DEVICE_MODEL_NAME.ANTENNA_RFID,
    DEVICE_MODEL_NAME.CAMERA_LPR,
   ]

// Device models that require facial recognition to enable liveness
export  const LIVENESS_REQUIRES_FACIAL = [
    DEVICE_MODEL_NAME.ARATEK_BD8500
];

// Modes where zone selection should be disabled
export const DISABLED_ZONE_BY_MODE = [MODE_MODEL.FOODIE_KIOSK];
// Allowed modes per device model configuration
export const ALLOWED_MODES_BY_DEVICE = {
    [DEVICE_MODEL_NAME.TELPO_TPS_450]: [MODE_MODEL.ATTENDANCE, MODE_MODEL.GUARD],
    [DEVICE_MODEL_NAME.TELPO_K5]: [MODE_MODEL.FOODIE_KIOSK],
    [DEVICE_MODEL_NAME.TELPO_F10]: [MODE_MODEL.ACCESS, MODE_MODEL.ATTENDANCE, MODE_MODEL.ACCESS_AND_ATTENDANCE, MODE_MODEL.FOODIE_ACCESS, MODE_MODEL.FOODIE_CHECK_OUT, MODE_MODEL.FOODIE_CHECK_IN,  MODE_MODEL.RESERVATIONS],
    [DEVICE_MODEL_NAME.TELPO_K10]: [MODE_MODEL.FOODIE_KIOSK, MODE_MODEL.VISITORS_MANAGEMENT_KIOSK],
    [DEVICE_MODEL_NAME.CAMERA_LPR]: [MODE_MODEL.CAMERA_LPR],
    [DEVICE_MODEL_NAME.ANTENNA_RFID]: [MODE_MODEL.ANTENNA],
    [DEVICE_MODEL_NAME.ARATEK_BM7550]: [MODE_MODEL.ATTENDANCE, MODE_MODEL.GUARD],
    [DEVICE_MODEL_NAME.ARATEK_BA8300]: [MODE_MODEL.ACCESS, MODE_MODEL.ATTENDANCE, MODE_MODEL.ACCESS_AND_ATTENDANCE, MODE_MODEL.FOODIE_ACCESS, MODE_MODEL.FOODIE_CHECK_OUT, MODE_MODEL.FOODIE_CHECK_IN,  MODE_MODEL.RESERVATIONS],
    [DEVICE_MODEL_NAME.ARATEK_BM5510]: [MODE_MODEL.GUARD],
    [DEVICE_MODEL_NAME.ARATEK_BD8500]: [MODE_MODEL.FOODIE_KIOSK, MODE_MODEL.VISITORS_MANAGEMENT_KIOSK],
};
// Disable "Show User List" for specific device + mode
export const DISABLE_REQUEST_SIGNATURE_ALWAYS_BY_MODE = {
    [DEVICE_MODEL_NAME.ARATEK_BD8500]: [MODE_MODEL.VISITORS_MANAGEMENT_KIOSK],
    [DEVICE_MODEL_NAME.TELPO_K10]: [MODE_MODEL.VISITORS_MANAGEMENT_KIOSK],
};

export const getIconClassesContainer = (list) => {
    if(list.map(e => e.deviceAccessTypeId || e.deviceAccessType?.id).includes(DEVICE_ACCESS_TYPE_MODEL.ENTRY_EXIT.id)) return 'w-46px text-right';
    return '';
}


export const DEVICE_DETAILS_MODEL = {
    data :{
        ip: '',
        sn: '',
        mac: '',
        zone: '',
        modeId  : '',
        idDevice: '',
        zoneName: '',
        deviceId: '',
        password: null,
        accessType: 4,
        deviceName: '',
        deviceType: '',
        statusValue: '',
        description: null,
        deviceRestrictionId: null
    },

    options:{
        timeZoneValue: 13,
        showWeapon: false,
        showVehicle: false,
        showLed: false,
        showAccessDialog: false,
        showLastAccess: false,
        showLogo: false,
        showUserList: false,
        synchorizeSelfies: false,
        playSounds: false,
        printer: false,
    },

    security: {
        antiPassBackType: 1,
        antiPassBackTime: '',
        antiPassBackAlert: 1,
        escortMode: 1,
        syncTime: 0,
        requestSignature: 0,
        requestSignatureAlways: false,
        validationNumber: 0
    },

    authentication:{
        readAfter: 1,
        authentication: 0,
        smartCard: false,
        facialRecognition: false,
        qr: false,
        pin: false,
        fingerprint: false,
        bluetooth: false,


        cameraTypeId: 0,
        liveness: false,
        enableDistance:false,
        distance:'',
        consecutiveOpeningsAllowed: 0
    },

    relay :{
        delayToOpen: 0,
        keepOpenRelay: 0
    },
    unoFa :{
        enableRelay1FA:false,
        openRelayForAll1FA:false
    },
    dosFa:{
        enableRelay2FA:false,
        openRelayForAll2FA:false
    },

    toRegister: function () {
        const {
            data,
            options,
            security,
            authentication,
            relay,
            unoFa,
            dosFa
        } = this;

        return {
            ...data,
            ...options,
            ...security,
            ...authentication,
            ...relay,
            ...unoFa,
            ...dosFa
        };
    }
};
export const STEPS_CREATE_DEVICE = {
    DATA: {
        INDEX: 0,
        TRANS: "data",
    },
    OPTIONS: {
        INDEX: 1,
        TRANS: "options",
    },
    SECURITY: {
        INDEX: 2,
        TRANS: "security",
    },
    AUTHENTICATION: {
        INDEX: 3,
        TRANS: "authentication",
    },
    RELAY: {
        INDEX: 4,
        TRANS: "relay",
    },
    UNOFA: {
        INDEX: 5,
        TRANS: "1fa",
    },
    DOSFA: {
        INDEX: 6,
        TRANS: "2fa",
    },
    SUMMARY: {
        INDEX: 7,
        TRANS: "summary",
    }
}
export const STEPS_UPDATE_DEVICE = {
    DATA: {
        INDEX: 0,
        TRANS: "data",
    },
    OPTIONS: {
        INDEX: 1,
        TRANS: "options",
    },
    SECURITY: {
        INDEX: 2,
        TRANS: "security",
    },
    AUTHENTICATION: {
        INDEX: 3,
        TRANS: "authentication",
    },
    RELAY: {
        INDEX: 4,
        TRANS: "relay",
    },
    UNOFA: {
        INDEX: 5,
        TRANS: "1fa",
    },
    DOSFA: {
        INDEX: 6,
        TRANS: "2fa",
    }
}
export const AUTHENTICATION_MODEL = {
    ONE_FA : 'ONE_FA',
    TWO_FA : 'TWO_FA'
}
export const TABS_FA = {
    CUSTOM_ACCESS:{
        key:0,
        name: "CUSTOM_ACCESS",
        translation: "custom_access",
        icon: <IconCardCustomAccess width={24} height={24}/>,
        permission: permissionObj?.WEB_DEVICE_CREATE
    },
    DEPARTMENTS:{
        key:1,
        name: "DEPARTMENTS",
        translation: "departments",
        icon: <IconChipDepartment width={24} height={24}/>,
        permission: permissionObj?.WEB_DEVICE_CREATE
    }
}
export const CUSTOM_ACCESS_TABS = {
    ADD_EMPLOYEES: {
        key: 0,
        name: "ADD_EMPLOYEES",
        translation: "add_employees",
        icon: <IconPersonPlusCard width={24} height={24}/>,
        permission: permissionObj?.WEB_DEVICE_CREATE,
    },
    ASSIGNED_EMPLOYEES:{
        key:1,
        name: "ASSIGNED_EMPLOYEES",
        translation: "assigned_employees",
        icon: <IconChipMultiplePerson width={24} height={24}/>,
        permission: permissionObj?.WEB_DEVICE_CREATE,
    },

    getTabsByTABS: (id) => {
        const hasId = id !== null && id !== undefined;

        return Object.values(CUSTOM_ACCESS_TABS)
            .filter(e => typeof e === 'object' && e.key !== undefined)
            .filter(e =>
                hasId || e.key !== CUSTOM_ACCESS_TABS.ASSIGNED_EMPLOYEES.key
            );
    }
}
export const DEPARTMENT_TABS = {
    ADD_DEPARTMENT:{
        key:0,
        name: "ADD_DEPARTMENT",
        translation: "add_department",
        icon: <IconPersonPlusCard width={24} height={24}/>,
        permission: permissionObj?.WEB_DEVICE_CREATE,
    },
    ASSIGNED_DEPARTMENT:{
        key:1,
        name: "ASSIGNED_EMPLOYEES",
        translation: "assigned_department",
        icon: <IconChipDepartment width={24} height={24}/>,
        permission: permissionObj?.WEB_DEVICE_CREATE,
    },

    getTabsByTABS: (id) => {
        const hasId = id !== null && id !== undefined;

        return Object.values(DEPARTMENT_TABS)
            .filter(e => typeof e === 'object' && e.key !== undefined)
            .filter(e =>
                hasId || e.key !== DEPARTMENT_TABS.ASSIGNED_DEPARTMENT.key
            );
    }
}
